import { type TranslationKeys, init } from "ui-common/i18n";

import en from "./en.json";
import nl from "./nl.json";

const translations = { en, nl } as const;
export type TranslationKey = TranslationKeys<typeof translations>;

export const { t, setLanguage, translate } = init(translations);

// Re-export needed functions and types
export { type Language, LanguageController } from "ui-common/i18n";
